import React from 'react';
import Truncate from 'react-truncate';

import { CoreLink } from '@uncinc/react-drupal-core';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentHit } from '../../types';

import './style.scss';

const SearchAllContentResultsHit = ({ hit }: { hit: SearchAllContentHit }) => {
  const url = hit.url[0];
  const title = hit.title[0];
  const body = hit.body?.[0];

  return (
    <article className="SearchAllContent__Results__Hit">
      <div className="SearchResult__title">
        <CoreLink href={url}>
          <h2>{title}</h2>
        </CoreLink>
      </div>
      {body && (
        <div className="SearchResult__body">
          <Truncate lines={2} ellipsis="...">
            <WysiwygField
              property="schema:text"
              html={body}
            />
          </Truncate>
        </div>
      )}
    </article>
  );
};

export default SearchAllContentResultsHit;
